import { LOADING } from '../constants'

const initialState = {
	// '/':false
}

export default function update(state = initialState, action) {
  if (action.type === LOADING) {
    // return action.loading
    return Object.assign({}, state, {
                [action.data._id]:action.data.loading
            })
  }
  return state
}



// WEBPACK FOOTER //
// ./src/reducers/loadingReducer.js